// import React from "react";
// import GradeImprovementCalculator from "./GradeImprovementCalculator";
// import GradeImprovementCalculatorMobile from "./GradeImporvementMobile";

// function App() {
//   return (
//     <div className="App">
//       <GradeImprovementCalculatorMobile />
//     </div>
//   );
// }

// export default App;

import React from "react";
import { useState, useEffect } from "react";
import DesktopVersion from "./GradeImprovementCalculator.jsx";
import MobileVersion from "./GradeImporvementMobile.jsx";

const App = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 650;

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return width < breakpoint ? <MobileVersion /> : <DesktopVersion />;
};

export default App;
